window.config = {
  webPath: '',

  itradeAPI: location.origin,
  itradePath: 'api',

  MDSStreamingAPI: 'ws://ttl2aacloud01.tx-tech.com/streaming',
  MDSSnapshotAPI: 'ws://ttl2aacloud01.tx-tech.com/snapshot',
  MDSOthersAPI: 'ws://ttl2aacloud01.tx-tech.com/info',
  MDSPath: 'pubsub',

  MDSEntityKey: 'SCB',
  MDSSuperkey: 'shcb2txtech01keyencrypt20key0315',

  winvestorAPI: location.origin,
  winvestorPath: 'ttl/api',

  winvestorDeviceID: 'itrade7.5-web-ttl',
  winvestorConsumerId: 'winvestor_ttl_broker',
  winvestorConsumerSecret: '$2y$10$i2c7LGyreYVUYjvQg1huUupnLufpzTugDyelyaowsZGe36j8N5KFi',

  // en_US 英 zh_CN 简 zh_TW 繁
  defaultLanguage: 'zh_CN', 

  companyOptions: {
    trading: {
      autoRefreshOrderEnquiry: 5000,
      autoCheckSession: 300000,
      refreshSession: false
    }
  }
}